import { Dispatch, SetStateAction } from 'react';
import { Code } from 'constants/codes';
import { Utility } from 'helpers/UtilityHelpers'
import { MessageType } from 'models/BaseModel';

const ValidateForm = (
  e: React.FormEvent,
  setMessage: Dispatch<SetStateAction<MessageType>>,
  keyword: string = "req",
): boolean => {
  e.preventDefault();

  let errors: string[] = [];
  const elements = document.querySelectorAll(`.${keyword}`);

  elements.forEach((element) => {
    const selected = element as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement  | HTMLDivElement ;
    //const title = selected.getAttribute("title") || "Highlighted field is required";
    const title = selected.getAttribute("title") || "Highlighted field is required";

    ////console.log("----->",selected.tagName,selected)

    if (selected.tagName === "INPUT") {
      const input = selected as HTMLInputElement;

      if (!input.value.trim()) {
        errors.push(title);
        input.classList.add("ferror");
      } else {
        const idName = input.id?.toLowerCase() || "";

        if (
          (idName.includes("email") && !Utility.isValid.Email(input.value)) ||
          (idName.includes("phone") && !Utility.isValid.PhoneFormat(input.value))
        ) {
          errors.push(`Invalid ${title}`);
          input.classList.add("ferror");
        } else {
          input.classList.remove("ferror");
        }
      }
    } 
    else if (selected.tagName === "TEXTAREA") {
      const textarea = selected as HTMLTextAreaElement;
      if (!textarea.value.trim()) {
        errors.push(title);
        textarea.classList.add("ferror");
      } else {
        textarea.classList.remove("ferror");
      }
    } 
    else if (selected.tagName === "SELECT") {
      const select = selected as HTMLSelectElement;
      if (select.value === "0" || select.value === "2") {
        errors.push(title);
        select.classList.add("ferror");
      } else {
        select.classList.remove("ferror");
      }
    } 
    else if (selected.tagName === "DIV") {
      const div = selected as HTMLDivElement;
      const valueControl = div.querySelector<HTMLDivElement>(
        "div[class$='-singleValue'], div[class$='-placeholder']"
      );
      const classControl = div.querySelector<HTMLDivElement>("div[class*='-control']");

      if (valueControl && classControl) {
        const value = valueControl.innerText.trim();
        if (!value || value.toLowerCase() === "select" || value.toLowerCase() === "search") {
          errors.push(title);
          classControl.classList.add("ferror");
        } else {
          classControl.classList.remove("ferror");
        }
      }
    }
  });

  if (errors.length > 0) {
    Utility.Message.Missing(errors,setMessage);
    setTimeout(() => {
    setMessage(Code.Message.None);
    }, 4000);
    return false;
  }

  return true;
};

const DeleteCurrentRecord = (
  activeId: number | undefined,
  setMessage: (messages: MessageType) => void
): void => {
 
  const messages: string[] = [`Are you sure you want to ${activeId === Code.Option.Active.DELETE? "restore" : "delete"} this record?`];

  if (messages.length > 0) {
    setMessage({messages:messages, type:Code.Message.type.CONFIRMTION});
  }
};

const DeleteMultipleRecords = (
  activeId: number,
  selectedItems: string[],
  setConfirm: (messages: MessageType) => void
):void => {

  if (selectedItems.length > 0) {

    const messages: string[] = [`Are you sure you want to ${activeId === Code.Option.Active.DELETE? "restore" : "delete"} the selected records?`];

    if (messages.length > 0) {
      setConfirm({messages:messages, type:Code.Message.type.CONFIRMTION});
    } 
  }
};

const DeleteSingleRecord = (
  activeId: number | undefined,
  selectedKeyId: string | undefined,
  setSelectedItems: (messages: string[]) => void,
  setConfirm: (messages: MessageType) => void,
):void => {

  if (selectedKeyId) {

    setSelectedItems([selectedKeyId]);

    const messages: string[] = [`Are you sure you want to ${activeId === Code.Option.Active.DELETE? "restore" : "delete"} this record?`];

    if (messages.length > 0) {
      setConfirm({messages:messages, type:Code.Message.type.CONFIRMTION});
    } 
  }
};

export const Toast = {
  Delete:{
    CurrentRecord: DeleteCurrentRecord,
    MultipleRecords: DeleteMultipleRecords,
    SingleRecord: DeleteSingleRecord,
  },
  Validate:{
    Form: ValidateForm
  }
  
}

